

const applyInfo = {
  state: {
    active: 0,
    isXy: '',
    id: '',
    policyName: '',
    baseInfo: {},
    bussInfo: {},
    agentBo: {},
    xyInfo: {},
    title: '',
    changeStatu: '',
    fileUrl: '',
    matterName: ''
  },

  mutations: {
    Settitle: (state, title) => {
      console.log(title)
      state.title = title
    },
    SetActive: (state, active) => {
      state.active = active
    },
    SetIsXy: (state, isXy) => {
      state.isXy = isXy
    },
    SetId: (state, id) => {
      state.id = id
    },
    SetPolicyName: (state, policyName) => {
      state.policyName = policyName
    },
    SetMatterName: (state, matterName) => {
      state.matterName = matterName
    },
    SetBaseInfo: (state, baseInfo) => {
      state.baseInfo = baseInfo
    },
    SetBussInfo: (state, bussInfo) => {
      state.bussInfo = bussInfo
    },
    SetAgentBo: (state, agentBo) => {
      state.agentBo = agentBo
    },
    SetxyInfo: (state, xyInfo) => {
      state.xyInfo = xyInfo
    },
    SetChangeStatu: (state, changeStatu) => {
      state.changeStatu = changeStatu
    },
    SaveApplyFile: (state, fileUrl) => {
      state.fileUrl = fileUrl
    }
  }
}

export default applyInfo